import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { Report, ReportVersion } from "app/api/graph/types";
import { createReportRoute, editReportVersionRoute, reportRoute } from "app/route/Routes";
import { CreateReportForm } from "app/component/report/CreateReportForm";
import { Maybe } from "app/util/type";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";

export const CreateReportScreen: FC = () => {
    const [report, setReport] = useState<
        (Pick<Report, "_id"> & { latestVersion?: Maybe<Pick<ReportVersion, "_id">> }) | undefined
    >(undefined);

    return report?.latestVersion ? (
        <Navigate to={editReportVersionRoute.build({ reportId: report._id, versionId: report.latestVersion?._id })} />
    ) : report ? (
        <Navigate to={reportRoute.build({ reportId: report._id })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createReportRoute} />
                <CreateReportForm onCreate={setReport} />
            </Container>
        </NavigationScreen>
    );
};
